import AddActions from "../Components/AddActions";

export default function ActionsSettings() {
    return (
        <AddActions />
    )
}